<template>
  <div class="search">
    <h1 class="results-title">Results for "{{ $route.query.query }}"</h1>
    <div class="columns" v-if="recipes && recipes.length > 0">
      <div class="column">
        <div class="module-card-wrap">
          <CardLink class="module-card" v-for="recipe in recipes" :key="recipe.key" size="small" :data="recipe" type="search" />
        </div>
      </div>
    </div>
    <div v-else-if="!recipes" id="loading-screen">
      <h1>Loading...</h1>
    </div>
    <div v-else-if="recipes.length < 1" id="no-results">
      <h1>No results returned for "{{ $route.query.query }}"</h1>
    </div>
  </div>
</template>

<style lang="sass">
@import "../styles/variables"

.results-title
  display: block
  font: 800 28px $font-serif
  padding: 10px 0 20px

.module-card-wrap
  display: flex
  flex-wrap: wrap
  gap: 10px

  .module-card
    min-width: 100%
    flex-direction: column
    gap: 10px

    @media (min-width: 768px)
      width: calc(50% - 10px)
      min-width: 0

    @media (min-width: 769px)
      width: calc(33% - (20px / 3))
      min-width: 0

    @media (min-width: 1200px)
      width: calc(25% - (30px / 4))
      min-width: 0
</style>

<script>
import CardLink from "../components/CardLink";
export default {
  components: {CardLink},
  methods: {
    updateRecipes() {
      this.$impressions.sendEvent('app_recipes_search', this.$route.query.query);
      document.title = this.$route.query.query + ' - My Recipe Finder';

      this.$cache.Get('search_' + this.$route.query.query, 20, async () => {
        return await this.$recipes.Search(this.$route.query.query);
      }).then(recipes => this.recipes = recipes);
    }
  },
  watch: {
    '$route.query.query'() {
      this.updateRecipes()
    }
  },
  created() {
    this.updateRecipes()
  },
  data() {
    return {
      recipes: undefined
    }
  }
}
</script>